<div *ngIf="trendChartData.series.length > 0; else noDataTemplate">
  <div class="trend-chart-header">
    <trend-chart-legend
      [legends]="trendChartData.legend"
      [size]="size"
      [isCount]="trendChartData.isCount"
    ></trend-chart-legend>
    <toggle
      *ngIf="trendChartData.hasToggle && size !== 'small'"
      [labels]="toggleLabels"
      [checked]="trendChartData.isCount"
      (toggleClick)="onToggleClick()"
    >
    </toggle>
  </div>
  <div
    echarts
    (chartInit)="onChartInit($event)"
    [options]="chartOption"
    [autoResize]="true"
    class="trend-chart-container"
    [ngClass]="size"
  ></div>
</div>

<ng-template #noDataTemplate>
  <drilldown-chart-no-data-available [size]="size"></drilldown-chart-no-data-available>
</ng-template>
